
import MKInput from "components/MKInput"; 
import Icon from "@mui/material/Icon";
import MKBox from "components/MKBox"; 
import MKButton from "components/MKButton"; 
import MKTypography from "components/MKTypography";  
import SiteLayout from "components/Layouts/SiteLayout";
import Divider from "@mui/material/Divider";
import { Buffer } from 'buffer';
import { useState } from "react";
 

export default function AppUtil() {  
    
    const [keyData, setKeyData] = useState({pemkey:"", converted:false, result:""})
    const [converted, setConverted] = useState(false)
     

    const copyKeyValue = () => {
        navigator.clipboard.writeText(keyData.result)  
    }

    const convertPEMToBase64 = () => {
        
        //const base64 = btoa(keyData.pemkey); 

        const base64 = Buffer.from(keyData.pemkey).toString('base64')

        onChangePemKeyValue('result', base64)
        setConverted(true)
        return base64;  
    }


    const onChangePemKeyValue = (name, value)=> {
        setKeyData(  { ...keyData, [name]: value });
        
    } 
 

    return (
          <SiteLayout>

          
        <MKBox p={2}> 

            <MKTypography color="dark" variant="header" >Encode string to Base64 format</MKTypography>
            <Divider sx={{ mt: 2, maxWidth: 'md'  }} />

            <MKBox>  
                

                <MKTypography color="dark" variant="body2" >We use browser to convert string only by using Buffer.from('abcdef').toString('base64')</MKTypography>
                 
                <MKBox display="flex" alignItems="center">  
                    <MKTypography color="dark" variant="body2" >Convert PEM Key or string to Base64 string:</MKTypography>
                    {
                    keyData.pemkey.length > 0 &&
                    <MKButton variant="text" color="primary"  sx={{ marginTop: 0.5 }} onClick={convertPEMToBase64}>
                        Convert
                    </MKButton>
               
                    }   
                </MKBox>
               
     
            </MKBox>
            <MKInput  multiline fullWidth rows={10} name="pemkey" placeholder="-----BEGIN ENCRYPTED PRIVATE KEY-----
            MIIB4jBMM7IskcT8Z4Euu6GKZxy9TQY6nD8V/G3uw487/B1GujAgMBAAE=
            -----END ENCRYPTED PRIVATE KEY-----"  sx={{ maxWidth: 'md' }} value={keyData.pemkey} onChange={evt => onChangePemKeyValue('pemkey', evt.target.value)}/> 
           

            <Divider sx={{ mt: 2, maxWidth: 'md'  }} /> 
            {keyData.result && <MKBox>  
                <MKBox display="flex" alignItems="center">  
                    <MKTypography color="dark" variant="body2" >Base64 Encoded String:</MKTypography>
                    
                    <MKButton variant="text" color="primary"  size="large" onClick={copyKeyValue} >
                        <Icon fontSize="large">copy</Icon>
                    </MKButton>   
                </MKBox> 
                <MKInput  multiline fullWidth rows={15} name="result" variant="outlined" sx={{ maxWidth: 'md' }} value={keyData.result}/> 
           </MKBox> 
            }


        </MKBox> 
        </SiteLayout>
    )

}
